import {License} from "../const/license";


export enum BillingCycle {
    Monthly = 'monthly',
    Yearly  = 'yearly'
}

export enum LicenseType {
    Free        = 'free',
    Pro         = 'pro',
    Business    = 'business',
    Enterprise  = 'enterprise'
}

export enum LicensePlanType {
    Flat10      = 'flat-10',
    Flat15      = 'flat-15',
    PayPerUser  = 'pay-per-user'
}

export default class LicenseProto {

    public license          : License

    public name             : string = 'INCORRECT LICENSE'

    public maxUsers         : number = 250
    public maxStorage       : string = '1 Gb'
    public isPro            : boolean = false;
    public isBusiness       : boolean = false;

    public prohibitedHomeViews      : any[] = []
    public prohibitedProjectViews   : any[] = []
    public prohibitedPortfolioViews : any[] = []
    public prohibitedCustomViews    : any[] = []

    public billingAndFinance        : boolean = true

    public customFields             : boolean = true
    public customTaskTypes          : boolean = true

    public requests                 : boolean = true
    public forms                    : boolean = true

    public isTrial                  : boolean = false
    public isPaid                   : boolean = false

    public isFlatRate               : boolean = false

    public licenseUsers             : any = false



    constructor(license:License) {

        this.license        = license   // const License.TYPE

        this.name           = 'INCORRECT LICENSE';

        this.maxUsers       = 250;
        this.maxStorage     = '1 Gb';
        this.isPro          = false;

    }

    homeView(viewId:any) {
        return !this.prohibitedHomeViews.includes(viewId);
    }

    customView(viewId:any) {
        return !this.prohibitedCustomViews.includes(viewId);
    }

    projectView(viewId:any) {
        return !this.prohibitedProjectViews.includes(viewId);
    }

    portfolioView(viewId:any) {
        return !this.prohibitedPortfolioViews.includes(viewId);
    }

    get automations() {
        return this.isPro
    }
}